// Chart.js configuration for global availability
// This ensures Chart.js is loaded before any Turbo navigation occurs

import { Chart, registerables } from 'chart.js'

// Register all Chart.js components (scales, elements, plugins, etc.)
Chart.register(...registerables)

// Make Chart available globally for inline scripts and Stimulus controllers
window.Chart = Chart

console.log('Chart.js loaded and registered globally')
